<div style="padding: 20px;">
  <h5>UPDATE {{templateName | uppercase}}</h5>
  <form [formGroup]="envelopeContentForm" (ngSubmit)="onSubmit()" *ngIf="dbTemplateName?.toLowerCase() !== _templateName?.AOB; else AOBForm">
    <mat-form-field appearance="outline" style="width: 100%;" *ngIf="(dbTemplateName?.toLowerCase() === _templateName?.CONSENT || dbTemplateName?.toLowerCase() === _templateName?.LPPCANCELLATION) && data?.applicant_type?.toLowerCase() === _appType?.PRIMARY; else coApp">
      <mat-label>Name</mat-label>
      <input matInput formControlName="envelopeOwnerName">
    </mat-form-field>
    <ng-template #coApp>
      <div *ngIf="dbTemplateName?.toLowerCase() === _templateName?.CONSENT">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Firstname</mat-label>
          <input matInput formControlName="co_applicant_firstname">
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Lastname</mat-label>
          <input matInput formControlName="co_applicant_lastname">
        </mat-form-field>
      </div>
    </ng-template>
    <div *ngIf="dbTemplateName.toLowerCase() === _templateName?.SOB">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Speak on Behalf Name</mat-label>
        <input matInput formControlName="SOBFullName">
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Relationship</mat-label>
        <input matInput formControlName="SOBRelationship">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email">
      <mat-error *ngIf="(envelopeContentForm.get('email')?.dirty || envelopeContentForm.get('email')?.touched) && envelopeContentForm.get('email')?.invalid">
        Please enter a valid email.
      </mat-error>  
    </mat-form-field>

    <div style="display: flex; gap: 10px; justify-content: flex-end;">
      <button type="button" mat-button (click)="cancel()">Cancel</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="!envelopeContentForm.valid">
        Save
      </button>
    </div>
  </form>
  <ng-template #AOBForm>
    <form [formGroup]="envelopeContentForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Primary Name</mat-label>
        <input matInput formControlName="envelopeOwnerName">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Primary Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Co-applicant Firstname</mat-label>
        <input matInput formControlName="co_applicant_firstname">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Co-applicant Lastname</mat-label>
        <input matInput formControlName="co_applicant_lastname">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Co-applicant Email</mat-label>
        <input matInput formControlName="co_applicant_email">
      </mat-form-field>
      <div style="display: flex; gap: 10px; justify-content: flex-end;">
        <button type="button" mat-button (click)="cancel()">Cancel</button>
        <button type="submit" mat-raised-button color="primary" [disabled]="!envelopeContentForm.valid">
          Save
        </button>
      </div>
    </form>
    
  </ng-template>  
</div>

